/**
 * @ngdoc Controller
 * @name TagSettingsController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('TagSettingsController', TagSettingsController).run(["$templateCache", function($templateCache) {
            // Override select template to slightly alter it
            $templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{'select2-container-active select2-dropdown-open open': $select.open, 'select2-container-disabled': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{ 'installationsettings.type_here' | i18n }} \" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{'select2-display-none': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
    }]);

    /**
     * @constructor
     * @ngInject
     */
    function TagSettingsController(
        $log,
        $scope,
        $stateParams,
        vrmNotificationsService,
        vrmNotificationType,
        InstallationsService,
        ApiService,
        locale
    ) {

        $log.info('TagSettingsController');
        $scope.tags = InstallationsService.tags
        $scope.select = {
            tags: [],
        };

        $scope.removeTag = (tag) => {
            ApiService.removeTag($stateParams.id, {
                tag: tag.label
            });
        }

        $scope.addTag = (tags) => {
            const poppedTag = tags && tags.pop();
            //If poppedTag is an object with the label property, access it and lowercase it
            const label = poppedTag && poppedTag.label
            ? poppedTag.label.toLowerCase()
            //else just lowercase the poppedtag
            : (poppedTag && poppedTag.toLowerCase());
            const inList = tags.filter((el) => {
                return el.label.toLowerCase() === label;
            }).length !== 0

            if (inList) {
                locale.ready('tags').then(() => {
                    vrmNotificationsService.add({
                        type: vrmNotificationType.WARNING,
                        message: locale.getString('tags.duplicate_tags_warning')
                    });
                })
                return;
            }
            tags.push({label: label, source: 'user'})

            ApiService.addTag($stateParams.id, {
                tag: label
            });
        }

        $scope.isUserTag = (tag) => {
            return tag.source === 'user'
        }

        $scope.notInTagList = (tag) => {
            return $scope.select.tags.filter((el) => {
                    if (el.label) return el.label.toLowerCase() === tag.label.toLowerCase()
                    return el.toLowerCase() === tag.label.toLowerCase()
                }
            ).length == 0;
        }

        InstallationsService.getInstallation($stateParams.id).then(function(installation) {
            redirectUnauthorizedUser(installation);

            if (installation.tags) {
                $scope.select.tags = installation.tags.filter((tag) => tag.source=='user').map(function (tag) {
                    return {"label": tag.name, "source": tag.source};
                });
            }
        });

        const redirectUnauthorizedUser = (installation) => {
            if (!installation.view_permissions.update_settings) {
                InstallationsService.redirectUnauthorizedUser(installation);
            }
        }
    }

})();
